/**
 * Small shims for @google/genai Live session objects (shared by tutor + Picture Talk).
 */

export function pickSendClientContent(session: unknown): ((text: string) => Promise<void>) | null {
  const s = session as Record<string, unknown> | null;
  if (!s) return null;
  if (typeof s.sendClientContent === 'function') {
    return async (text: string) =>
      (s.sendClientContent as (x: unknown) => Promise<void>)({
        turns: [{ role: 'user', parts: [{ text }] }],
        turnComplete: true,
      });
  }
  if (typeof s.send === 'function') {
    return async (text: string) =>
      (s.send as (x: unknown) => Promise<void>)({
        clientContent: {
          turns: [{ role: 'user', parts: [{ text }] }],
          turnComplete: true,
        },
      });
  }
  return null;
}

/**
 * Sends a one-shot user text turn so Live can speak first (avoids waiting on mic/VAD).
 * Uses {@link pickSendClientContent} (sendClientContent or legacy send).
 */
export async function sendLiveOpeningTextOrFallback(session: unknown, text: string): Promise<void> {
  const send = pickSendClientContent(session);
  if (!send) return;
  await send(text);
}

export function pickRealtimeInput(session: unknown): ((payload: unknown) => unknown) | null {
  const s = session as Record<string, unknown> | null;
  if (!s) return null;
  if (typeof s.sendRealtimeInput === 'function') {
    return (s.sendRealtimeInput as (p: unknown) => unknown).bind(s);
  }
  if (typeof s.sendRealTimeInput === 'function') {
    return (s.sendRealTimeInput as (p: unknown) => unknown).bind(s);
  }
  return null;
}
